module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/assessment_achievements/1@2x_be7993681d2830c05d017a2bd0b2c2e2.png";